/**
 * 分类/导航相关接口
 */
import request from './request'

/**
 * 获取首页导航分类
 */
export function getCategory() {
  return request.post('/api/index/getCategory')
}
